module.exports = __webpack_public_path__ + "static/media/video-case-cpg.283f0f78.mp4";